<template>
  <div class="gfr-layout">
    <slot />
  </div>
</template>
<script lang="ts" setup></script>
<style scoped lang="postcss">
.gfr-layout {
  @apply flex flex-col w-full min-h-screen;
}
</style>
